import { AppBar, Button, Toolbar, useMediaQuery } from '@mui/material'
import * as React from 'react'
import { AuthDialogComponent } from '../../Auhentication/LoginComponent/AuthDialogComponent'
import LinkPopoverComponent from '../../AppBarComponent/LinkPopoverComponent'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import { Theme, useTheme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { AnalyticService } from '../../../lib/analytics/analyticService'
import { useRouter } from 'next/router'
import { SchoolLogo } from '../../School/SchoolLogoComponent'
import useUserAuthStatus from '../../Auhentication/useUserAuthStatus'
import SchoolAdditionalLinkPopoverComponent from '../../AppBarComponent/SchoolAdditionalLinkPopoverComponent'
import {
  ISchool,
  ISchoolAdditionalLinks,
} from '../../../interfaces/school.interface'

interface IInfoAppBarProps {
  school_details: ISchool
  hideButtons?: boolean
  showMenuButton?: boolean
  onMenuButtonClicked?: () => void
  defaultStyle?: React.CSSProperties
  appbarStyle?: React.CSSProperties
  linkStyle?: React.CSSProperties
  additionalLinks?: ISchoolAdditionalLinks[]
}

const useStyles = makeStyles((theme: Theme) => {
  createStyles({
    appBar: {
      position: 'relative' as 'relative',
      // position: "fixed" as "fixed"
    },
    flex: {
      flex: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  })
})

export default function InfoAppBar(props: IInfoAppBarProps) {
  const [onClient, setOnClient] = React.useState(false)
  // const [prevScrollPos, setPreviousScrollPos] = React.useState(0);
  // const [visible, setVisible] = React.useState(true);
  const [openAuthDialog, setOpenAuthDialog] = React.useState(false)

  const classes: any = useStyles()
  const router = useRouter()

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const userAuthHook = useUserAuthStatus()

  React.useEffect(() => {
    setOnClient(true)

    // window.addEventListener("scroll", handleScroll);

    return () => {
      console.log('about to unmount InfoAppBar')
    }
  }, [])

  const toggleOpenAuthDialog = () => {
    setOpenAuthDialog(!openAuthDialog)
  }

  return (
    <div
      className="navContent"
      style={{
        backgroundColor: 'white',
        height: '55px',
        ...props.defaultStyle,
      }}
    >
      <AppBar
        style={{
          backgroundColor: '#fff',
          position: 'fixed',
          // borderBottom: "solid #0000000a 1px",
          background: 'inherit',
          boxShadow:
            '0 2px 2px -2px rgba(34,47,62,.1), 0 8px 8px -4px rgba(34,47,62,.07)',
          ...props.appbarStyle,
        }}
      >
        <Toolbar style={{ overflowX: 'auto' }}>
          {props.showMenuButton && (
            <IconButton
              aria-label="Open drawer"
              onClick={() => {
                props.onMenuButtonClicked && props.onMenuButtonClicked()
              }}
              className={classes.menuButton}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          )}

          <Button
            href={props.school_details?.custom_home_url || '/'}
            style={{
              ...props.linkStyle,
            }}
            onClick={() => {
              if (props.school_details.custom_home_url) {
                location.href = props.school_details.custom_home_url
              } else {
                router.push('/')
              }
            }}
          >
            <span>
              <SchoolLogo school={props.school_details} logoOnly={true} />
            </span>
            {!isSmallScreen && <b>Home</b>}
          </Button>

          {/*<Button*/}
          {/*  style={{*/}
          {/*    ...props.linkStyle,*/}
          {/*  }}*/}
          {/*  onClick={() => {*/}
          {/*    router.push("/quiz");*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <b>Quiz</b>*/}
          {/*</Button>*/}

          {!props.hideButtons && onClient && userAuthHook.userDetails && (
            <>
              <span style={{ display: 'flex', flexGrow: 1 }} />
              <SchoolAdditionalLinkPopoverComponent
                schoolDetails={props.school_details}
                additionalLinks={props.additionalLinks}
              />
              <Button
                href={'/dashboard'}
                style={{
                  ...props.linkStyle,
                  minWidth: '105px',
                }}
                variant={'contained'}
                color={'primary'}
                disableElevation={true}
                onClick={() => {
                  AnalyticService.onMyCourseClicked({
                    buttonElement: 'topButton',
                  })
                  router.push('/dashboard')
                }}
              >
                {userAuthHook.userDetails?.user_type === 'admin'
                  ? 'Dashboard'
                  : 'My courses'}
              </Button>

              {['teacher', 'student'].includes(
                userAuthHook.userDetails?.user_type,
              ) && (
                <LinkPopoverComponent schoolDetails={props.school_details} />
              )}
            </>
          )}

          {!props.hideButtons && onClient && !userAuthHook.userDetails && (
            <>
              <span style={{ display: 'flex', flexGrow: 1 }} />
              <SchoolAdditionalLinkPopoverComponent
                schoolDetails={props.school_details}
                additionalLinks={props.additionalLinks}
              />
              <div>
                <Button
                  disableElevation={true}
                  color="primary"
                  onClick={toggleOpenAuthDialog}
                  style={{
                    marginRight: '10px',
                    minWidth: '150px',
                    // ...props.linkStyle,
                  }}
                  variant="contained"
                >
                  Login / Register
                </Button>
              </div>
            </>
          )}
        </Toolbar>
      </AppBar>
      <div style={{ height: '55px' }} />
      <AuthDialogComponent
        school_details={props.school_details}
        openAuthDialog={openAuthDialog}
        closeAuthDialogFunction={toggleOpenAuthDialog}
      />
      <style>
        {`
          .navbar {
            width: 100%;
            /* padding: 10px; */
            position: fixed;
            z-index: 3;
            top: 0;
            transition: top 0.6s;
          }
          
          .navbar--hidden {
            top: -60px;
          }
          `}
      </style>
    </div>
  )
}
